"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyTransformDependencies = void 0;

var _dependenciesIsIntegerGenerated = require("./dependenciesIsInteger.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var applyTransformDependencies = {
  isIntegerDependencies: _dependenciesIsIntegerGenerated.isIntegerDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createApplyTransform: _factoriesAny.createApplyTransform
};
exports.applyTransformDependencies = applyTransformDependencies;